<div [ngClass]="{'show':isShown}" class="slide-out modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title"><ng-content select=".header"></ng-content></h5>
      <button (click)="hide()" class="close">
          <i class="fa fa-close"></i>
      </button>
    </div>
    <div class="modal-body">
      <ng-content select=".form-body"></ng-content>
    </div>
    <!-- <div class="modal-footer">
      <ng-content select=".footer"></ng-content>
    </div> -->
  </div>
</div>
